var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{staticClass:"group-deal-card my-5 mx-5",on:{"click":_vm.viewGroupDeal}},[(_vm.dealPhoto)?_c('v-img',{staticClass:"deal-photo",attrs:{"src":_vm.dealPhoto}}):_c('v-card',{staticClass:"group-deal-no-image"},[_c('h2',[_vm._v("No Image")])]),_c('span',[_vm._v(_vm._s(_vm.dealData.dealName)+" ("+_vm._s(_vm.dealData.groupSize)+")")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }